angular.module('logbook')
  .controller('log-audit', ['$scope', '$rootScope', '$http', '$q', '$filter', '$location', '$route', '$sanitize',
	  function($scope, $rootScope, $http, $q, $filter, $location, $route, $sanitize) {
        let searchDefer = $q.defer();

         $scope.query = {};
         $scope.log = $rootScope.selectedLog;
         
         $scope.diffBlacklist = [
            "_links",
            "created",
            "createdBy",
            "updated",
            "updatedBy",
            "handler",
            "hibernateLazyInitializer",
            "id",
            "status.id",
            "status.name",
            "status.sortOrder",
            "soon",
            "late",
            "contentType",
            "role.sortOrder",
            "role.name",
            "log.signInNoteTemplate",
            "log.signOutNoteTemplate",
            "log",
            "newMillis",
            "millisToPaymentExpiration",
            "millisToFeatureExpiration",
            "millisToSentinelPaymentExpiration",
            "noteId",
            "reminderId",
            "log.logOwner.paymentExpires",
            "log.notesNewMinutes",
            "log.adminRequiredForTagEdit",
            "templateSegmentId",
            "tabularFormat",
            'safeHtmlNote',
            'maxHeight',
            'commentsToShow'
         ];

         $scope.revisionTypes = ['Add', 'Modify', 'Delete'];

         $scope.entityTypes = ['Note', 'Reminder', 'Log', 'TagValue', 'FileAttachment', 'LogInvitation', 'LogUser'];

         $scope.dmp = new diff_match_patch();
         
         $scope.diffFieldMap = {
               'status.description': 'Status',
               'request' : 'Reminder',
               'role.description' : 'Role',
               'log.name': 'Log'
         };
         
         $scope.updateDate = function()
         {
            $scope.query['from'] = $scope.fromDate && $scope.fromDate.toISOString();
            $scope.query['to'] = $scope.toDate && $scope.toDate.toISOString();
         };
         
         $scope.diffKeys = [
            "note",
            "stringValue",
            "numericValue",
            "request",
            "comment"
         ];

         $scope.prepareUi = () => {
             let search = $location.search();

             Object.keys(search).forEach(function (key) {
                 let val = search[key];
                 if ('from' == key || 'to' == key)
                     val = new Date(val).toISOString();

                 if (key === 'revisionTypes' || key === 'types') {
                     $scope.query[key] = {};
                     if (val) {
                         val = [].concat(val);
                         val.forEach(v => $scope.query[key][v] = true);
                     }
                 } else
                     $scope.query[key] = val;

                 if ('from' == key)
                     $scope.fromDate = new Date(val);
                 if ('to' == key)
                     $scope.toDate = new Date(val);
             });

             if (Object.keys($scope.query).length == 1) {
                 $scope.fromDate = new Date();
                 $scope.fromDate.setDate($scope.fromDate.getDate() - 1);
                 $scope.updateDate();
             }
         }

          $scope.startQuery = () => {
              let queryToRun = angular.extend({}, $scope.query);
              if ($scope.query.userAccess) {
                  queryToRun['types'] = ['LogUser', 'LogInvitation'];
              }

              ['types', 'revisionTypes'].forEach(t => $scope.convertMultiSelectModelToQueryString(t, queryToRun, $scope.query[t]));

              const priorCancelPromise = searchDefer.promise;

              searchDefer.resolve();
              searchDefer = $q.defer();

              const cancelPromise = searchDefer.promise;
              cancelPromise.suppressErrorFlag = true;

              $scope.revisions = [];

              priorCancelPromise.then(() => {
                  $scope.loading = true;
                  $scope.tooManyResults = false;
                  $scope.error = false;

                  return $http.get('/audit', {
                      params: queryToRun,
                      noIndicator: true,
                      noErrorPopup: true,
                      timeout: cancelPromise
                  }).then(function (result) {
                      let revisions = result.data._embedded && result.data._embedded.revisions;
                      if (!revisions)
                          revisions = [];
                      let typesToIds = {};
                      let typesToRevisions = {};
                      let templateId = null;
                      $scope.tabularNotes = {};
                      revisions.forEach(function (revision) {

                          if (!typesToIds[revision.metadata.entityType]) {
                              typesToIds[revision.metadata.entityType] = [];
                              typesToRevisions[revision.metadata.entityType] = [];
                          }
                          let ids = typesToIds[revision.metadata.entityType];
                          let revisions = typesToRevisions[revision.metadata.entityType];

                          if (revision.metadata.entityType === 'Note' && revision.entity.templateId)
                              templateId = revision.entity.templateId;
                          if (revision.metadata.entityType === 'Note' && revision.entity.tabularFormat)
                              $scope.tabularNotes[revision.entity.id] = true;
                          if (revision.metadata.revisionType === 'INSERT') {
                              let index = ids.indexOf(revision.entity.id);
                              if (index >= 0) {
                                  ids.splice(index, 1);
                                  revisions.splice(index, 1);
                              }
                          }
                          else {
                              let index = ids.indexOf(revision.entity.id);
                              if (index < 0) {
                                  ids.push(revision.entity.id);
                                  revisions.push(revision.metadata.revisionNumber);
                              } else {
                                  revisions.splice(index, 1, revision.metadata.revisionNumber);
                              }
                          }
                      });

                      $scope.templateId = templateId;

                      let requests = [];

                      if (templateId) {
                          requests.push($http.get('/api/templateSegments/', {
                              timeout: cancelPromise,
                              noIndicator: true,
                              noErrorPopup: true,
                              params: {
                                  'template': templateId,
                                  'size': 10000
                              }
                          }));
                      }

                      Object.keys(typesToIds).forEach(function (type) {
                          if (type != 'NoteTemplateValue') {
                              var ids = $scope.partition(typesToIds[type], 100);
                              var revisions = $scope.partition(typesToRevisions[type], 100);
                              for (var i = 0; i < ids.length; i++) {
                                  var params = {
                                      'log': $scope.log.id
                                  };
                                  params['ids.' + type] = ids[i].join(',');
                                  params['revisions.' + type] = revisions[i].join(',');
                                  requests.push($http.get('/audit/previousRevisions', {
                                      params: params,
                                      timeout: cancelPromise
                                  }));
                              }
                          }
                      });

                      return $q.all(requests).then(function (prevRevResults) {

                          $scope.prevRevisions = [];
                          prevRevResults.forEach(function (prevRevResult) {
                              if (prevRevResult.data._embedded) {
                                  if (prevRevResult.data._embedded.revisions)
                                      $scope.prevRevisions = $scope.prevRevisions.concat(
                                          prevRevResult.data._embedded.revisions);
                                  else if (prevRevResult.data._embedded.templateSegments) {
                                      $scope.templateSegments = {};
                                      prevRevResult.data._embedded.templateSegments.forEach(function (segment) {
                                          $scope.templateSegments[segment.id] = segment;
                                      });
                                  }
                              }
                          });

                          $scope.revisionMap = {};
                          $scope.prevRevisionMap = {};
                          $scope.prevRevisions.forEach(function (rev) {
                              $scope.prevRevisionMap[rev.metadata.entityType + '.' + rev.entity.id]
                                  = rev;
                          });

                          revisions.forEach(function (revSearch) {
                              let key =
                                  revSearch.metadata.entityType + '.'
                                  + revSearch.entity.id + '.'
                                  + revSearch.metadata.revisionNumber;

                              revisions.forEach(function (revFind) {
                                  if (revFind.metadata.entityType === revSearch.metadata.entityType
                                      && revFind.entity.id === revSearch.entity.id
                                      && revFind.metadata.revisionNumber < revSearch.metadata.revisionNumber
                                      && !$scope.revisionMap[key])
                                      $scope.revisionMap[key] = revFind;
                              });
                          });

                          $scope.auditDisplay = {};
                          revisions.forEach(function (rev) {
                              $scope.auditDisplay[rev.metadata.entityType + '.' + rev.entity.id + '.' + rev.metadata.revisionNumber] = $scope.calcAuditDisplay(rev);
                          });
                          $scope.revisions = revisions;
                      });

                  });
              })
              .catch((err) => {
                  if (err?.data?.message?.includes('Too many results')) {
                      $scope.tooManyResults = true;
                  } else {
                      $scope.error = true;
                  }
                  $scope.revisions = [];
              })
              .finally(() => {
                  if (cancelPromise === searchDefer.promise) {
                      $scope.loading = false;
                  }
              })
          }


         $scope.runQuery = function()
         {
            Object.keys($scope.query).forEach(function(key) {
               if( key === 'types' || key === 'revisionTypes' )
               {
                  let selectedOpts = Object.keys($scope.query[key]).filter(k => $scope.query[key][k]);
                  if( selectedOpts.length )
                     $location.search(key, selectedOpts).replace();
                  else
                     $location.search(key, undefined).replace();
               }
               else
                  $location.search(key, $scope.query[key]).replace();
            });

            $scope.startQuery();
         };

         $scope.convertMultiSelectModelToQueryString = function(key, query, value)
         {
            if( !value || !query || !key )
               return;
            if( typeof(value) === 'string' )
               value = {value: true};
            let selectedOpts = Object.keys(value).filter(k => value[k]);
            if( selectedOpts.length )
               query[key] = selectedOpts;
            else
               delete query[key];
         }

         $scope.calcAuditDisplay = function(rev)
         {
            
            var prev = $scope.revisionMap[
                   rev.metadata.entityType + '.' 
                 + rev.entity.id + '.' 
                 + rev.metadata.revisionNumber];
            
            if( !prev )
               prev = $scope.prevRevisionMap[
                    rev.metadata.entityType + '.' 
                 + rev.entity.id];
            
            var diff = [];
            
            $scope.addDiff(prev ? prev.entity : null, rev.entity, diff);
            
            return diff;
         };
         
         $scope.addDiff = function(prev, current, diff, prefix)
         {
            var dateTest = new RegExp(/[0-9]{4}-[0-1][0-9]-[0-3][0-9]T[0-2][0-9]:[0-5][0-9]:[0-6][0-9]/);
            var valueTest = new RegExp(/.*Value.*/);
            Object.keys(current).forEach(function(key) {
               var prefixedKey = (prefix ? prefix+'.' : '')+key;
               if( (!prev || $scope.isDifferent(prev[key], current[key]))
                     && $scope.diffBlacklist.indexOf(key) < 0 
                     && (key != 'note' || !$scope.tabularNotes[current['id']])
                     && $scope.diffBlacklist.indexOf(prefixedKey) < 0 )
               {
                  if( key == 'acknowledgements' )
                  {
                     for( var i=0; i<current[key].length; i++ )
                     {
                        var curAck = current[key][i];
                        var isNew = true;
                        for( var j=0; prev && j < prev[key].length; j++ )
                           if(prev[key][j].id == curAck.id)
                           {
                              isNew = false;
                              break;
                           }
                        if( isNew )
                        {
                           var value = $filter('date')(curAck.created, 'MM-dd-yyyy HH:mm:ss.sss')
                              + ' by ' + curAck.createdBy.firstName + ' ' + curAck.createdBy.lastName;
                           diff.push({
                              'key': 'Acknowledged',
                              'value': value
                           });
                        }
                     }
                  }
                  else if( typeof(current[key]) == 'object' && current[key] )
                  {
                     $scope.addDiff(prev ? prev[key] : null, current[key], diff, prefixedKey);
                  }
                  else if( (current[key] && (!prev || !prev[key]))
                          || (!current[key] && (prev && prev[key]) )
                          || (current[key] && prev[key] && current[key] != prev[key]))
                 {
                     var value = current[key];
                     var displayKey = $scope.diffFieldMap[prefixedKey] || prefixedKey;
                     if( key.endsWith("Time")
                         || dateTest.test(value))
                        try {
                           value = $filter('date')(value, 'MM-dd-yyyy HH:mm:ss.sss');
                        } catch(error) {}
                     if( displayKey == 'acknowledged' )
                        value = 'Yes';
                     value = $sanitize(value);
                     if( $scope.diffKeys.indexOf(key) >= 0 && prev )
                     {
                        var d = $scope.diff_lineMode($sanitize(prev[key]), value);
                        //$scope.dmp.diff_cleanupSemantic(d);
                        value = $scope.dmp.diff_prettyHtml(d);
                     }
                     else
                        value = $scope.escapeHtml(value);
                     diff.push({
                        'key' : displayKey, 
                        'value' : value
                     });
                 }
               }
            });
            prev && Object.keys(prev).forEach(function(key) {
               if( prev.hasOwnProperty(key) && !current.hasOwnProperty(key))
               {
                  var prefixedKey = (prefix ? prefix+'.' : '')+key;
                  var displayKey = $scope.diffFieldMap[prefixedKey] || prefixedKey;
                  diff.push({'key':displayKey, 'value':'[removed]'});

               }
            });
         };
         $scope.partition = function(items, size) {
            var p = [];
            var i,j,k=0;
            for (i=0,j=items.length; i<j; i+=size) {
                p[k++] = items.slice(i,i+size);
            }
            for( i=0; i < p.length; i++ )
               console.log('p['+i+'].length='+p[i].length);
            return p;
        }
         
         
         $scope.isDifferent = function(prev, current)
         {
            console.log(JSON.stringify(prev) + ": " + typeof(prev));
            if(typeof(prev) == 'object')
            {
               if( (!prev && current) 
                   || (prev && !current) 
                   || (prev && current && prev.length != current.length ) )
                  return true;
               
               if( !current && !prev )
                  return false;
               
               /*for( var i=0; i < prev.length; i++ )
                  if( prev[i] != current[i] )
                     return true;*/
               var objDiff = false;

               if( Array.isArray(current) )
               {
                  var a1 = current.map(val => val._links ? val._links.self.href : val).sort();
                  var a2 = prev.map(val => val._links ? val._links.self.href : val).sort();
                  if( a1.length != a2.length )
                     objDiff = true;
                  else
                     for( var i=0; i < a1.length; i++ )
                        if( a1[i] != a2[i] )
                           objDiff = true;
               }
               else
               {
                  Object.keys(current).forEach(function(key) {
                     if( prev[key] != current[key] )
                        objDiff = true;
                  });
               }
               if( objDiff )
                  return true;
               
               return false;
            }
            return prev != current;
         }
         $scope.diff_lineMode = function(text1, text2) {
            var pattern_para = /&#10;/g;
            text1 = text1.replace(pattern_para, '\n');
            text2 = text2.replace(pattern_para, '\n');
            var a = $scope.dmp.diff_linesToChars_(text1, text2);
            var lineText1 = a['chars1'];
            var lineText2 = a['chars2'];
            var lineArray = a['lineArray'];

            var diffs = $scope.dmp.diff_main(lineText1, lineText2, false);

            $scope.dmp.diff_charsToLines_(diffs, lineArray);
            return diffs;
          }
         $scope.escapeHtml = function(txt) {
            var pattern_amp = /&/g;
            var pattern_lt = /</g;
            var pattern_gt = />/g;
            var pattern_para = /&#10;/g;
            return txt.replace(pattern_para, '\n').replace(pattern_amp, '&amp;').replace(pattern_lt, '&lt;')
               .replace(pattern_gt, '&gt;');
         };
         diff_match_patch.prototype.diff_prettyHtml = function (diffs) {
            var html = [];
            var pattern_para = /\n/g;
            for (var x = 0; x < diffs.length; x++) {
              var op = diffs[x][0]; // Operation (insert, delete, equal)
              var data = diffs[x][1]; // Text of change.
              var text = $scope.escapeHtml(data).replace(pattern_para, '¶<br/>');
            switch (op) {
                case DIFF_INSERT:
                  html[x] = '<ins class="inserted-text">' + text + '</ins>';
                  break;
                case DIFF_DELETE:
                  if (text == "\r")
                    html[x] = '';
                  else
                    html[x] = '<del class="deleted-text">' + text + '</del>';
                  break;
              }
            }
            return html.join('');
          };

         $scope.prepareUi();
         const queryCopy = angular.copy($scope.query ?? {});
         delete queryCopy.from;
         delete queryCopy.to;
         delete queryCopy.log;

         if (Object.values(queryCopy).filter((x) => !!x).length) {
             $scope.startQuery();
         }

         $scope.$on('$destroy', () => {
            searchDefer.resolve();
         });
  }]);